<!--
* @description:
* @fileName publish.vue
* @author hvv
* @date 2022/01/13 14:42:27
!-->
<template>
  <div>
    <el-card class="filterContainer" shadow="always">
      <el-form class="demo-form-inline" :inline="true" :model="formInline">
        <el-form-item label="活动名称">
          <el-input v-model="formInline.user" placeholder="Approved by" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="formInline.region" placeholder="Activity zone">
            <el-option label="Zone one" value="shanghai" />
            <el-option label="Zone two" value="beijing" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- table -->
    <el-card class="tableContainer" shadow="always">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column fixed label="时间" prop="time" width="350" />
        <el-table-column label="活动名称" prop="name" width="120" />
        <el-table-column label="地址" prop="address" width="120" />
        <el-table-column label="海报" prop="poster" width="120" />
        <el-table-column label="人数" prop="count" width="120" />
        <el-table-column label="类型" prop="type" width="120" />
        <el-table-column label="直播地址" prop="liveUrl" width="160" />
        <el-table-column align="center" fixed="right" label="编辑" width="300">
          <template #default>
            <el-button size="small" type="text" @click="drawer = true">查 看</el-button>
            <el-button size="small" type="text">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 查看组件 -->
    <el-drawer v-model="drawer" :direction="direction" title="活动详情">
      <span>Hi, there!</span>
    </el-drawer>
  </div>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  export default defineComponent({
    name: 'Publish',
    setup() {
      const tableData = [
        {
          name: '活动名称',
          time: '2022-3-24 12:00:00 - 2022-3-24 14:00:00',
          address: '杭州博物馆',
          poster: '我是封面',
          type: '类型',
          count: '100人',
          liveUrl: 'https://www.live.com',
        },
        {
          name: '活动名称',
          time: '2022-3-24 12:00:00 - 2022-3-24 14:00:00',
          address: '杭州博物馆',
          poster: '我是封面',
          type: '类型',
          count: '100人',
          liveUrl: 'https://www.live.com',
        },
        {
          name: '活动名称',
          time: '2022-3-24 12:00:00 - 2022-3-24 14:00:00',
          address: '杭州博物馆',
          poster: '我是封面',
          type: '类型',
          count: '100人',
          liveUrl: 'https://www.live.com',
        },
        {
          name: '活动名称',
          time: '2022-3-24 12:00:00 - 2022-3-24 14:00:00',
          address: '杭州博物馆',
          poster: '我是封面',
          type: '类型',
          count: '100人',
          liveUrl: 'https://www.live.com',
        },
      ]
      const state = reactive({
        formInline: {
          user: '',
          region: '',
        },
        tableData,
        drawer: false,
        direction: 'rtl',
      })
      const onSubmit = () => {}

      return {
        ...toRefs(state),
        onSubmit,
      }
    },
  })
</script>
<style lang="scss" scoped>
  .filterContainer {
    padding: 10px;
    box-shadow: #ccc;
  }

  .tableContainer {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-top: 20px;
    background: #fff;
  }
</style>
